import { useCallback, useState } from 'react'
import { filter, indexOf, size } from 'lodash'

const useSelectedItemIds = allItemIds => {
  const [selectedItemIds, setSelectedItemIds] = useState([])

  const toggleSelectItemId = useCallback(
    itemId => {
      const foundIndex = indexOf(selectedItemIds, itemId)

      if (foundIndex < 0) {
        return setSelectedItemIds([...selectedItemIds, itemId])
      }

      const list = filter(selectedItemIds, item => item !== itemId)
      return setSelectedItemIds([...list])
    },
    [selectedItemIds],
  )

  const unselectAllItemIds = useCallback(() => {
    setSelectedItemIds([])
  }, [setSelectedItemIds])

  const toggleSelectAllItemIds = useCallback(() => {
    if (size(allItemIds) === size(selectedItemIds)) {
      unselectAllItemIds()
    } else {
      setSelectedItemIds(allItemIds)
    }
  }, [allItemIds, selectedItemIds, unselectAllItemIds])

  return {
    selectedItemIds,
    toggleSelectItemId,
    unselectAllItemIds,
    toggleSelectAllItemIds,
  }
}

export default useSelectedItemIds
